import React, { useMemo } from 'react';
import { useFlexLayout, useTable } from 'react-table';

import { ReactTableWrapper } from 'ui-components/components/react-table-wrapper/react-table-wrapper';

import style from '../style.module.less';
import { createActionsColumnDefinition } from './columns/actions';
import { createHeightColumnDefinition } from './columns/height';
import { createInsuranceColumnDefinition } from './columns/insurance';
import { createLengthColumnDefinition } from './columns/length';
import { createNameColumnDefinition } from './columns/name';
import { createWeightColumnDefinition } from './columns/weight';
import { createWidthColumnDefinition } from './columns/width';
import { EmptyPackageSetsPlaceholder } from './image/empty-package-sets-placeholder';

const getRowClassName = (row) => {
  return row?.original?.bodyRowClassName;
};

/**
 * @typedef {import('../../../../../prop-types/dimenstion-unit').DimensionUnit} DimensionUnit
 * @typedef {import('../../../../../prop-types/weight-unit').WeightUnit} WeightUnit
 */
/**
 * @param {object} props
 * @param {Array} props.data
 * @param {DimensionUnit} props.sellerDefaultDimensionsUnit
 * @param {WeightUnit} props.sellerDefaultWeightUnit
 * @returns {React.ReactElement}
 */
export const PackageSetsTable = ({ data, sellerDefaultDimensionsUnit, sellerDefaultWeightUnit }) => {
  const columns = useMemo(
    () => [
      createNameColumnDefinition(),
      createLengthColumnDefinition(),
      createWidthColumnDefinition(),
      createHeightColumnDefinition(),
      createWeightColumnDefinition(),
      createInsuranceColumnDefinition(),
      createActionsColumnDefinition(),
    ],
    [],
  );

  const { getTableProps, headerGroups, getTableBodyProps, rows, prepareRow } = useTable(
    {
      columns,
      data,
      sellerDefaultDimensionsUnit,
      sellerDefaultWeightUnit,
    },
    useFlexLayout,
  );

  return (
    <ReactTableWrapper
      className={style['package-sets-table']}
      emptyRow={<EmptyPackageSetsPlaceholder />}
      getBodyRowClassName={getRowClassName}
      getTableBodyProps={getTableBodyProps}
      getTableProps={getTableProps}
      headerGroups={headerGroups}
      headerRowClassName={style['header-row']}
      prepareRow={prepareRow}
      rows={rows}
    />
  );
};
